import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: 12px;\n  top: 28px;\n  position: absolute;\n  white-space: nowrap;\n  @media (max-width: ", "px) {\n    font-size: 10px;\n    top: 26px;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  background-color: #fff;\n  border-radius: 50%;\n  height: 8px;\n  width: 8px;\n\n  ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  background-color: ", ";\n  border-radius: 50%;\n  display: flex;\n  height: 22px;\n  justify-content: center;\n  position: relative;\n  width: 22px;\n  z-index: 2;\n\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import checkSvg from '../../assets/icons/check.svg';
import styled from '../../utils/styling/styled-components';
var Container = styled.div(_templateObject(), function (props) {
  return props.bgColor;
}, function (props) {
  return props.responsive && "\n    @media screen and (max-width: ".concat(props.theme.breakpoints.sm, "px) {\n      height: 16px;\n      width: 16px;\n    }\n  ");
});
var Dot = styled.div(_templateObject2(), function (props) {
  return props.responsive && "\n    @media screen and (max-width: ".concat(props.theme.breakpoints.sm, "px) {\n      height: 6px;\n      width: 6px;\n    }\n");
});
var Label = styled.div(_templateObject3(), function (props) {
  return props.theme.colors.stone;
}, function (props) {
  return props.theme.breakpoints.sm;
});

var Step = function Step(_ref) {
  var complete = _ref.complete,
      isChecked = _ref.isChecked,
      label = _ref.label,
      bgColor = _ref.bgColor,
      responsive = _ref.responsive,
      className = _ref.className;
  return /*#__PURE__*/React.createElement(Container, {
    bgColor: bgColor,
    responsive: responsive,
    className: className
  }, isChecked || complete ? /*#__PURE__*/React.createElement("img", {
    src: checkSvg,
    alt: ""
  }) : /*#__PURE__*/React.createElement(Dot, {
    responsive: responsive
  }), label && /*#__PURE__*/React.createElement(Label, null, label));
};

export { Step };